/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { productsUpdate } from "../../funcs/productsUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateProductRequest$inboundSchema,
};

export const tool$productsUpdate: ToolDefinition<typeof args> = {
  name: "products-update",
  description: `Update a product and its options.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await productsUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
